<template>
  <div id="app" class="min-h-screen bg-gray-50 dark:bg-gray-900">
    <!-- 메인 콘텐츠 -->
    <main class="main-content">
      <router-view />
    </main>

    <!-- 푸터 (선택사항) -->
    <!-- <Footer /> -->
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useAppStore } from '@/stores'

// 스토어 사용
const appStore = useAppStore()

// 앱 초기화
onMounted(() => {
  // 개발 환경에서 앱 정보 로깅
  if (import.meta.env.DEV) {
    console.log('🚀 Vue3 Admin App Started')
    console.log('Environment:', import.meta.env.MODE)
    console.log('API Base URL:', import.meta.env.VITE_API_BASE_URL)
  }
})
</script>

<style>
/* 글로벌 스타일은 Tailwind CSS로 처리 */
.main-content {
  min-height: calc(100vh - 4rem);
}
</style>
